import { PlayerEnum } from '../components/Player/constants';
import theme from '../theme/default';

export const getPlayerColor = (player: PlayerEnum): string => {
  switch (player) {
    case PlayerEnum.ONE:
      return theme.playerOne;
    case PlayerEnum.TWO:
      return theme.playerTwo;
    case PlayerEnum.THREE:
      return theme.playerThree;
    case PlayerEnum.FOUR:
      return theme.playerFour;
    default:
      console.error('COULD NOT MATCH PLAYER TO COLOR IN getPlayerColors');
      return 'black';
  }
};
